import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { saveDomainCart } from "../../../../Redux/Actions";
import LocalStorageHelper from "../../../../Utils/LocalStorageHelper";
import { TriangleIconProfileView } from "../../utils/svgIcons";
import "./ProfileViewModal.scss";
import { checkIsStaging, removeDomainCartFromLocalStorage } from "../../utils/common";
import { getEventPlatform, getUrlParamValue, redirectToDashy } from "../../../../Utils/common";
import {
  BRAND_WEBSITE_BUSINESS_CATEGORIES,
  DOMAIN_HISTORY,
  EXPLORE_THEME_ROUTE,
} from "../../../../Constants/routesConstant";
import { TRACKING_EVENTS } from "../../../../Utils/GAEvents/gaEventsConstants";
import { sendGAEvent } from "../../../../Utils/GAEvents";
import { DOMAIN, TEMP_TOKEN, UTM_SOURCE } from "../../../../Utils/constants";
export const ProfileViewModal = (props) => {
  const { mobileNo, handleCloseOpenProfile, postPurchase } = props;
  const { subscriptionData } = useSelector((state) => ({
    subscriptionData: state.themeReducer.subscriptionDetails,
  }));
  const dispatch = useDispatch();
  const handleLogoutHandler = () => {
    LocalStorageHelper.delete("auth_token");
    LocalStorageHelper.delete("token");
    LocalStorageHelper.delete(TEMP_TOKEN);
    removeDomainCartFromLocalStorage();
    window.location.href = checkIsStaging() ? "https://website.digitaldukaan.app/" : "https://digitalshowroom.in/";
    dispatch(
      saveDomainCart({
        cart_id: 0,
        type: 0,
        amount: 0,
        discounted_amount: 0,
        items: [],
      }),
    );
    handleCloseOpenProfile();
    sendGAEvent(TRACKING_EVENTS.logoutHeader, {
      dimension1: getUrlParamValue(DOMAIN),
      dimension2: getEventPlatform(),
      dimension3: getUrlParamValue(UTM_SOURCE),
      // Add more dimensions as needed
    });
  };
  const modalRef = useRef();
  const handleManageWebsiteSub = () => {
    sendGAEvent(TRACKING_EVENTS.manageWebsiteHeader, {
      dimension1: getUrlParamValue(DOMAIN),
      dimension2: getEventPlatform(),
      dimension3: getUrlParamValue(UTM_SOURCE),
      // Add more dimensions as needed
    });

    if (subscriptionData?.ecomSubscription?.subscription_type && subscriptionData?.brandWebsiteSubscription?.subscription_type) {
      redirectToDashy(`${EXPLORE_THEME_ROUTE}`);
    } else if (subscriptionData?.ecomSubscription?.subscription_type) {
      redirectToDashy(`${EXPLORE_THEME_ROUTE}`);
    } else if (subscriptionData?.brandWebsiteSubscription?.subscription_type) {
      redirectToDashy(`${BRAND_WEBSITE_BUSINESS_CATEGORIES}`);
    }
  };
  useEffect(() => {
    const excludedElements = ["top_section", "middle_section", "bottom_section", "triangle_icon"];
    const handleClickOutside = (event) => {
      if (
        modalRef.current &&
        !modalRef.current.contains(event.target) &&
        !excludedElements.some((className) => event.target.closest(`.${className}`))
      ) {
        handleCloseOpenProfile();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [handleCloseOpenProfile]);

  function handleManageDomainRedirection(data) {
    sendGAEvent(TRACKING_EVENTS.manageDomainHeader, {
      dimension1: getUrlParamValue(DOMAIN),
      dimension2: getEventPlatform(),
      dimension3: getUrlParamValue(UTM_SOURCE),
      // Add more dimensions as needed
    });
    redirectToDashy(data);
  }
  return (
    <div className={`profile_modal_wrapper ${postPurchase ? "postPurchase_header" : ""}`} ref={modalRef}>
      <div className="top_section">
        <p className="account">Account</p>
        <p className="number">{mobileNo}</p>
      </div>
      <div className="middle_section">
        {subscriptionData?.domain?.domain_name && 
          <div className="domain" onClick={() => handleManageDomainRedirection(`${DOMAIN_HISTORY}`)}>
            {" "}
            <span>Manage domains</span>
          </div>
        }
        {subscriptionData?.ecomSubscription?.subscription_type ||
        subscriptionData?.brandWebsiteSubscription?.subscription_type ? 
          <div className="website" onClick={handleManageWebsiteSub}>
            <span>Manage website</span>
          </div>
         : null}
      </div>
      <div
        className="bottom_section"
        onClick={(e) => {
          e.stopPropagation();
          handleLogoutHandler();
        }}
      >
        Logout
      </div>
      <span className="triangle_icon">
        <TriangleIconProfileView />
      </span>
    </div>
  );
};
